import { ApiInvalidParamError, ApiFatalError } from '@/errors/errors';
import { LOCAL_STORAGE_ACCESS_TOKEN_KEY, GUARDED_API_REQUEST_FAILED } from '@/helpers/constants';
import EventEmitter from '@/helpers/EventEmitter';

const getApiURL = (route) => `${process.env.VUE_APP_API_URL}/${route}`;

const apiRequest = async (route, requestOptions) => {
  // Remove lang parameter for default language
  route = route.toLowerCase();
  route = route.replace(`&lang=${process.env.VUE_APP_DEFAULT_API_LANGUAGE}`, '');
  route = route.replace('&lang=undefined', '');
  route = route.replace(`lang=${process.env.VUE_APP_DEFAULT_API_LANGUAGE}`, '');
  route = route.replace('lang=undefined', '');
  try {
    const url = getApiURL(route);

    const request = await fetch(url, { method: 'GET', credentials: 'include', ...requestOptions });

    const response = await request.json();

    if (request.status === 200) {
      return response;
    }

    if (request.status === 400) {
      throw new ApiInvalidParamError('Error', response);
    } else {
      throw new ApiFatalError('Fatal error', response);
    }
  } finally {
    // Nothing
  }
};

const guardedApiRawRequest = async (route, requestOptions) => {
  requestOptions = {
    method: 'GET',
    headers: {},
    ...requestOptions
  };
  requestOptions.headers.Authorization = `Bearer ${localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)}`;
  return apiRequest(route, requestOptions);
};

const guardedApiRequest = async (route, requestOptions) => {
  try {
    return await guardedApiRawRequest(route, requestOptions);
  } catch (e) {
    if (e instanceof ApiInvalidParamError) {
      // TODO: do something here ?
      console.error(`Guarded API request failed ( invalid param error ) for ${route}`, e.response);
    } else if (e instanceof ApiFatalError) {
      EventEmitter.emit(GUARDED_API_REQUEST_FAILED, { error: e });
      console.error(`Guarded API request failed ( fatal error ) for ${route}`, e.response);
    } else {
      EventEmitter.emit(GUARDED_API_REQUEST_FAILED, { error: e });
      console.error(`Guarded API request failed ( other fatal error ) for ${route}`, e.message);
    }
    throw e;
  }
};

export {
  getApiURL,
  guardedApiRequest,
  apiRequest
};
